/**
 * Prevent form multiple submitting
 */
function preventFormMultipleSubmitting() {
  window.addEventListener("DOMContentLoaded", () => {
    setTimeout(() => {
      const formElements = document.querySelectorAll("form");
      formElements.forEach((formElement) => {
        formElement.addEventListener("submit", (event) => {
          const submitButton = event.target.querySelector(
            "input[type='submit']"
          );
          const invalidFields = event.target.querySelectorAll(
            ".input-validation-error"
          );
          if (
            !submitButton ||
            invalidFields.length > 0 ||
            submitButton.disabled
          )
            return;
          setTimeout(() => {
            const animationContainer = document.createElement("div");
            animationContainer.classList.add("animate-submit-button");
            submitButton.setAttribute("disabled", "disabled");
            submitButton.parentNode.insertBefore(
              animationContainer,
              submitButton
            );
            animationContainer.appendChild(submitButton);
            setTimeout(() => {
              animationContainer.parentNode.insertBefore(
                submitButton,
                animationContainer
              );
              animationContainer.remove();
              submitButton.removeAttribute("disabled");
            }, 10000);
          }, 0);
        });
      });
    }, 0);
  });
}

preventFormMultipleSubmitting();

export default preventFormMultipleSubmitting;
